export default "__VITE_ASSET__Euy3EDH5__"